export const normalizeUrl = (raw: string): string | undefined => {
  const trimmed = raw.trim()
  if (!trimmed) return

  // Must be a single token; if the clipboard contains multiple words/lines, treat it as normal paste.
  if (/\s/.test(trimmed)) return

  // Common copy/paste includes trailing punctuation: "example.com," or "example.com)".
  const stripTrailingPunctuation = (value: string) => value.replace(/[)\].,;:!?]+$/, '')

  // Per UX: ONLY treat text as URL if it explicitly starts with http/https.
  // This prevents accidental link attachments from arbitrary words or hostnames.
  if (!/^https?:\/\//i.test(trimmed)) return

  const tryBuild = (value: string) => {
    try {
      const u = new URL(value)
      if (u.protocol !== 'http:' && u.protocol !== 'https:') return
      return u.toString()
    } catch {
      return
    }
  }

  const cleaned = stripTrailingPunctuation(trimmed)
  return tryBuild(cleaned)
}

export const getUrlName = (url: string): string => {
  try {
    const u = new URL(url)
    return u.hostname + (u.pathname && u.pathname !== '/' ? u.pathname : '')
  } catch {
    return url
  }
}